import { handleRequest } from "../utilities/requestHandler";

export const getAllCustomerSites = () =>
    handleRequest("get","/cus_sites/getsites");

export const updateSite = (siteId, siteData) =>
    handleRequest("put", `/cus_sites/sites/${siteId}`, siteData);

export const createSite = (siteData) =>
    handleRequest("post", "/cus_sites/sites/create", siteData);

export const deleteSites = (ids) =>
    handleRequest("post", "/cus_sites/sites/delete", { ids });

export const downloadSiteTemplate = () =>
    handleRequest("get", "/cus_sites/sites/template", null, {}, "blob");

export const bulkUploadSites = (formData) =>
    handleRequest("post", "/cus_sites/sites/bulk-upload", formData, { 'Content-Type': 'multipart/form-data' });